var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnCallTheme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4728_21511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2378 20.5492L23.3303 16.6417C21.9348 15.2462 19.5624 15.8044 19.0042 17.6186C18.5855 18.8746 17.19 19.5724 15.934 19.2932C13.143 18.5954 9.37503 14.9671 8.67727 12.0364C8.25861 10.7804 9.09592 9.38488 10.3519 8.96628C12.1661 8.40807 12.7243 6.03567 11.3288 4.64014L7.42129 0.732653C6.30486 -0.244218 4.63023 -0.244218 3.65336 0.732653L1.00185 3.38416C-1.64966 6.17522 1.28096 13.5715 7.83995 20.1305C14.3989 26.6895 21.7952 29.7597 24.5863 26.9686L27.2378 24.3171C28.2147 23.2007 28.2147 21.526 27.2378 20.5492Z",
    fill: "#FFBD05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4728_21511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCallTheme);
export default __webpack_public_path__ + "static/media/icn_call_theme.6ea2d9bec0aaa7c5e0423063d3fa72cc.svg";
export { ForwardRef as ReactComponent };